
























































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreatePrice from "./createprice.vue";
import EditPrice from "./editprice.vue";
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PagePriceRequest extends PageRequest {
  keyword: string;
  areaId: number;
  isEnable: number = 9; //nullable
  meterType: number = 0;
  costType: number = 0;
}

@Component({
  components: { CreatePrice, EditPrice },
})
export default class Prices extends AbpBase {
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PagePriceRequest = new PagePriceRequest();
  creationTime: Date[] = [];
  columnlist: any[] = [];
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  menuId: number = 0; //菜单Id
  choosecolumn: any[] = []; //右侧已选择列

  showcolumn: boolean = false; //显示列选择窗口
  splitnum: number = 0.15;

  //获取菜单Id
  getmenu() {
    let menulist = JSON.parse(localStorage.getItem("userAuth"));
    let menu = menulist.filter((ele) => {
      return ele.value == "price";
    });
    if (menu.length > 0) {
      this.menuId = menu[0].id;
    }
    let se = this.columns.filter((ele) => {
      return (
        ele.sortId == 0 ||
        ele.sortId == 1 ||
        ele.sortId == 30 ||
        ele.sortId == 39
      );
    });
    se.forEach((ele) => {
      this.columnlist.push(ele);
    });
  }
  //获取自定义字段
  async getuserfields() {
    let res = await this.$store.dispatch({
      type: "userfield/getuserfield",
      data: { menuId: this.menuId },
    });
    //把列加入右边列表
    this.columns.forEach((ele) => {
      if (
        ele.sortId != 0 &&
        ele.sortId != 1 &&
        ele.sortId != 30 &&
        ele.sortId != 39
      ) {
        this.choosecolumn.push({
          fieldName: ele.key,
          isShow: true,
          sortCode: ele.sortId,
          showTag: ele.title,
          menuId: this.menuId,
        });
      }
    });
    //如果设置了自定义列
    if (res.length > 0) {
      let restrue = res.filter((ele) => {
        return ele.isShow == true;
      });
      //this.choosecolumn = res;
      restrue.forEach((ele) => {
        let col = this.columns.filter((colum) => {
          return colum.key == ele.fieldName;
        });
        //加入显示列
        if (col.length > 0) {
          col[0].sortId = ele.sortCode;
          this.columnlist.push(col[0]);
        }
      });
      this.choosecolumn.forEach((ele) => {
        let col = restrue.filter((colum) => {
          return colum.fieldName == ele.fieldName;
        });
        if (col.length > 0) {
          ele.isShow = col[0].isShow;
        } else {
          ele.isShow = false;
        }
      });
    } else {
      this.columnlist = this.columns;
    }
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  //改变显示
  handleChange(event: any, val: any) {
    if (event) {
      //选中显示
      let showcol = this.columns.filter((col) => {
        return col.key === val;
      });
      if (showcol.length > 0) {
        let sh = this.choosecolumn.filter((p) => {
          return p.fieldName == val;
        });
        if (sh.length > 0) {
          showcol[0].sortId = sh[0].sortCode;
        }
        this.columnlist.push(showcol[0]);
      }
    } else {
      //不显示
      this.columnlist = this.columnlist.filter((col) => {
        return col.key !== val;
      });
    }
    //排序
    this.columnlist.sort((left, right): number => {
      if (left.sortId > right.sortId) return 1;
      if (left.sortId < right.sortId) return -1;
      return 0;
    });
  }
  get list() {
    return this.$store.state.price.list;
  }
  get loading() {
    return this.$store.state.price.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnable = val;
    this.$store.commit("itemdetail/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("itemdetail/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  async meterTypeDetail() {
    await this.$store
      .dispatch({
        type: "itemdetail/getdetaillist",
        data: 7,
      })
      .then((val) => {
        this.$data.meterTypedetail = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  async useTypeDetail() {
    await this.$store
      .dispatch({
        type: "itemdetail/getdetaillist",
        data: 10,
      })
      .then((val) => {
        this.$data.useTypedetail = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  pageChange(page: number) {
    this.$store.commit("price/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("price/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "price/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.price.pageSize;
  }
  get totalCount() {
    return this.$store.state.price.totalCount;
  }
  get currentPage() {
    return this.$store.state.price.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 80,
      align: "left",
      title: this.L("IndexNo"),
      fixed: "left",
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      resizable: true,
      sortId: 5,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  info.length > 0 ? info[0].displayName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].displayName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      resizable: true,
      sortId: 6,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
              },
            },
            info.length > 0 ? info[0].fullName : this.L("Unknown")
          ),
        ]);
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      fixed: "left",
      sortId: 2,
      resizabl: true,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.name,
            },
          },
          params.row.name
        );
      },
    },
    {
      title: this.L("MeterType"),
      key: "meterType",
      width: 90,
      sortId: 3,
      render: (h: any, params: any) => {
        let id = params.row.meterType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("Unit"),
      key: "unitName",
      width: 90,
      sortId: 4,
      resizabl: true,
    },
    {
      title: this.L("SettlementStandard"),
      key: "settlementStandard",
      width: 150,
      sortId: 4,
      render: (h: any, params: any) => {
        let id = params.row.settlementStandard;
        return h("div", [
          h(
            "span",
            {
              style: {
                display: "inline-block",
                width: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
              domProps: {
                title:
                  id == 2 ? this.L("StandardAmount") : this.L("StandardUse"),
              },
            },
            id == 2 ? this.L("StandardAmount") : this.L("StandardUse")
          ),
        ]);
      },
    },
    {
      title: this.L("BasePrice"),
      key: "basePrice",
      width: 90,
      sortId: 4,
    },
    {
      title: this.L("UnitNum"),
      key: "unitNum",
      width: 90,
      sortId: 5,
    },
    {
      title: this.L("UseCategory"),
      key: "costType",
      width: 130,
      sortId: 6,
      render: (h: any, params: any) => {
        let id = params.row.costType;
        let ite = JSON.parse(localStorage.getItem("itemdetail"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h("span", info.length > 0 ? info[0].name : this.L("Unknown"));
      },
    },
    {
      title: this.L("PriceCategory"),
      key: "priceType",
      width: 130,
      sortId: 7,
      render: (h: any, params: any) => {
        var str = this.L("Unknown");
        if (params.row.priceType == 0) {
          str = this.L("FixedPrice");
        } else if (params.row.priceType == 1) {
          str = this.L("PeakPinggu");
        } else if (params.row.priceType == 2) {
          str = this.L("StepPrice");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("Cycle"),
      width: 90,
      key: "cycle",
      sortId: 8,
      render: (h: any, params: any) => {
        var str = this.L("Unknown");
        if (params.row.cycle == 0) {
          str = this.L("Fixed");
        } else if (params.row.cycle == 1) {
          str = this.L("Year");
        } else if (params.row.cycle == 2) {
          str = this.L("HalfYear");
        } else if (params.row.cycle == 3) {
          str = this.L("Season");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("First") + this.L("Num"),
      key: "firstNum",
      width: 130,
      sortId: 9,
    },
    {
      title: this.L("First") + this.L("BasePrice"),
      key: "firstBasePrice",
      width: 130,
      sortId: 10,
    },
    {
      title: this.L("First") + this.L("Sewage"),
      key: "firstSewagePrice",
      width: 130,
      sortId: 11,
    },
    {
      title: this.L("First") + this.L("Server"),
      key: "firstSyntheticalPrice",
      width: 130,
      sortId: 12,
    },
    {
      title: this.L("Second") + this.L("Num"),
      key: "secondNum",
      width: 130,
      sortId: 13,
    },
    {
      title: this.L("Second") + this.L("BasePrice"),
      key: "secondBasePrice",
      width: 130,
      sortId: 14,
    },
    {
      title: this.L("Second") + this.L("Sewage"),
      key: "secondSewagePrice",
      width: 130,
      sortId: 15,
    },
    {
      title: this.L("Second") + this.L("Server"),
      key: "secondSyntheticalPrice",
      width: 130,
      sortId: 16,
    },
    {
      title: this.L("Third") + this.L("Num"),
      key: "thirdNum",
      width: 130,
      sortId: 17,
    },
    {
      title: this.L("Third") + this.L("BasePrice"),
      key: "thirdBasePrice",
      width: 130,
      sortId: 18,
    },
    {
      title: this.L("Third") + this.L("Sewage"),
      key: "thirdSewagePrice",
      width: 130,
      sortId: 19,
    },
    {
      title: this.L("Third") + this.L("Server"),
      key: "thirdSyntheticalPrice",
      width: 130,
      sortId: 20,
    },
    {
      title: this.L("Four") + this.L("Num"),
      key: "fourNum",
      width: 130,
      sortId: 21,
    },
    {
      title: this.L("Four") + this.L("BasePrice"),
      key: "fourBasePrice",
      width: 130,
      sortId: 22,
    },
    {
      title: this.L("Four") + this.L("Sewage"),
      key: "fourSewagePrice",
      width: 130,
      sortId: 23,
    },
    {
      title: this.L("Four") + this.L("Server"),
      key: "fourSyntheticalPrice",
      width: 130,
      sortId: 24,
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 90,
      sortId: 25,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("IsDefault"),
      key: "isdefault",
      width: 90,
      sortId: 26,
      render: (h: any, params: any) => {
        return h("span", params.row.isdefault ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("SortName"),
      key: "sortCode",
      width: 90,
      sortId: 27,
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      sortId: 28,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
    },
    {
      title: this.L("SummerFirstPrice"),
      key: "summerFirstPrice",
      width: 150,
      sortId: 31,
    },
    {
      title: this.L("SummerFirstServicePrice"),
      key: "summerFirstServicePrice",
      width: 150,
      sortId: 32,
    },
    {
      title: this.L("SummerSecondPrice"),
      key: "summerSecondPrice",
      width: 150,
      sortId: 33,
    },
    {
      title: this.L("SummerSecondServicePrice"),
      key: "summerSecondServicePrice",
      width: 150,
      sortId: 34,
    },
    {
      title: this.L("SummerThirdPrice"),
      key: "summerThirdPrice",
      width: 150,
      sortId: 35,
    },
    {
      title: this.L("SummerThirdServicePrice"),
      key: "summerThirdServicePrice",
      width: 150,
      sortId: 36,
    },
    {
      title: this.L("SummerFourPrice"),
      key: "summerFourPrice",
      width: 150,
      sortId: 37,
    },
    {
      title: this.L("SummerFourServicePrice"),
      key: "summerFourServicePrice",
      width: 150,
      sortId: 38,
    },
    {
      title: "Id",
      key: "id",
      width: 90,
      sortId: 39,
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 150,
      sortId: 30,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('priceDel');
        let edit = this.checkButtonAuth('priceEdit');
        return h("div", [
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("price/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "price/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getmenu();
    await this.getuserfields();
    this.pagerequest.isEnable = 9;
    this.getAreaTree();
    this.meterTypeDetail();
    this.useTypeDetail();
    this.getpage();
  }
  data() {
    return {
      meterTypedetail: [],
      useTypedetail: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
